import React from 'react'

import type { IconProps } from './types'

const Quote: React.FC<IconProps> = ({
  size = 24,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 32.143V49.2859H29.1429V32.143H17.7143C17.7143 25.8414 22.8413 20.7144 29.1429 20.7144V15.0001C19.6897 15.0001 12 22.6899 12 32.143ZM52 20.7144V15.0001C42.5468 15.0001 34.8571 22.6899 34.8571 32.143V49.2859H52V32.143H40.5714C40.5714 25.8414 45.6984 20.7144 52 20.7144Z"
        fill={color}
      />
    </svg>
  )
}

export default Quote
